import React, {useEffect} from "react";
import AuthProvider from "../Views/AuthProvider";
import {updateDocumentTitle} from "../../Utils/Common";

// Shared page shell so every screen matches the original admin layout:
// AuthProvider gate → .page-content → .page-content-header (title + optional
// right-aligned actions) → .container-fluid content. Renders identical markup to
// the pre-existing pages (e.g. Riders/Listing.js) so the whole portal is consistent.
const PageLayout = ({title, actions, children}) => {
    useEffect(() => {
        if (title) updateDocumentTitle(title);
    }, [title]);

    return (
        <AuthProvider>
            <div className="page-content">

                <header className="page-content-header widgets-header">
                    <div className="container-fluid">
                        <div className="tbl tbl-outer">
                            <div className="tbl-row">

                                <div className="tbl-cell">
                                    <div className="tbl tbl-item">
                                        <div className="tbl-row">
                                            <div className="tbl-cell">
                                                <div className="title">
                                                    <h5 style={{fontWeight: 700}}>{title}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {actions && (
                                    <div className="tbl-cell">
                                        <div className="tbl tbl-item">
                                            <div className="tbl-row">
                                                <div className="tbl-cell">
                                                    <div className="title text-right" style={{display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "flex-end", gap: 12}}>
                                                        {actions}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </header>

                <div className="container-fluid">
                    {children}
                </div>

            </div>
        </AuthProvider>
    );
};

export default PageLayout;
